import React, { useContext, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { isEmpty } from "lodash";
import AuthContext from "../context/AuthContext";

const FooterNew = () => {
  const { user, setShowMiniCasino, showMiniCasino, openBetsToogle } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const [sportsHovered, setSportsHovered] = useState(false);

  const bottomNavItems = [
    { id: 'home', label: 'Home', icon: '/bottombar/home.svg', path: '/' },
    { id: 'inplay', label: 'In-Play', icon: '/bottombar/inplay.svg', path: '/inplay' },
    { id: 'sports', label: 'Sports', icon: '/bottombar/sports.svg', path: '/sports' },
    { id: 'casino', label: 'Casino', icon: '/bottombar/ChipRotate.gif', path: '/casino' },
    { id: 'account', label: 'Account', icon: '/bottombar/profile.svg', path: '/account' },
  ];

  const handleNavClick = (item) => {
    if (item.id === 'account') {
      if (isEmpty(user)) {
        navigate('/login');
        return;
      }
      navigate('/new-profile');
    } else if (item.id === 'casino') {
      // open the mini-casino bottom-sheet lobby instead of a full page
      setShowMiniCasino(true);
    } else {
      navigate(item.path);
    }
  };

  const sportsActive = currentPath === '/sports' && !showMiniCasino;
  const archFill = (sportsHovered || sportsActive) ? '#2b5771' : '#1e323e';

  return (
    <div className="">
      <ul>
        <div className="style09">
          <nav className="cls-footer-sec sk-footer" style={{ left: '0', borderTop: 'none', outline: 'none', zIndex: openBetsToogle ? 1000000 : undefined }}>
            <ul style={{ display: "flex", justifyContent: "space-between" }}>
              {bottomNavItems.map((item) => {
                const isSports = item.id === 'sports';
                // When the mini-casino sheet is open, highlight Casino (the
                // URL stays on the current page, so fall back to the flag).
                const isActive = item.id === 'casino'
                  ? showMiniCasino
                  : !showMiniCasino && currentPath === item.path;

                return (
                  <li
                    key={item.id}
                    id={item.id}
                    className={isActive ? 'active' : ''}
                    onClick={() => handleNavClick(item)}
                    onMouseEnter={() => isSports && setSportsHovered(true)}
                    onMouseLeave={() => isSports && setSportsHovered(false)}
                    style={{ position: 'relative' }}
                  >
                    {/* Arch bump for Sports only */}
                    {isSports && (
                      <svg
                        width="80"
                        height="36"
                        viewBox="0 0 80 38"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          position: 'absolute',
                          top: '-34px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          display: 'block',
                          overflow: 'visible',
                          transition: 'fill 0.2s',
                        }}
                      >
                        <path d="M0,36 Q40,0 80,36 L80,38 L0,38 Z" fill={archFill} />
                      </svg>
                    )}

                    {item.id === 'casino' ? (
                      <a
                        href="javascript:void(0)"
                        className="ui-link"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowMiniCasino(true);
                        }}
                      >
                        <img
                          src={item.icon}
                          alt={item.label}
                          style={{ filter: 'none' }}
                        />
                        {item.label}
                      </a>
                    ) : (
                      <Link to={item.path} className="ui-link">
                        <img
                          src={item.icon}
                          alt={item.label}
                          style={
                            isSports
                              ? { width: '30px', height: '30px', marginTop: '-3px' }
                              : {}
                          }
                        />
                        {item.label}
                      </Link>
                    )}
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </ul>
    </div>
  );
};

export default FooterNew;
